import './style';
import 'babel-polyfill';
import AppRoot from './components/AppRoot';
import { render } from 'preact';
import { applyMiddleware, createStore, compose } from 'redux';
import RootReducer from './reducers/RootReducer';
import thunk from 'redux-thunk';
import { REDUX_DEV_TOOLS } from './parameters';
import container from './services/Container';
import MediaQueryListener from './listeners/MediaQueryListener';
import { normalizeInitialDataAction } from './actions/UtilityActions';

const body = document.body;
let app = document.getElementById('app');

if (app) {
	// Handle initialization into already pre-rendered html
	while (app.firstChild) {
		app.removeChild(app.firstChild);
	}
}
else {
	// Handle development mode - no pre-rendering
	const div = document.createElement('div');
	div.id = 'app';
	div.className = 'h-100';
	body.appendChild(div);
	app = div;
}

let store;
let initialState = window.__INITIAL_STATE__;

if (REDUX_DEV_TOOLS) {
	const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
	store = createStore(RootReducer.reduce, initialState, composeEnhancers(applyMiddleware(thunk)));
}
else {
	store = createStore(RootReducer.reduce, initialState, applyMiddleware(thunk));
}

MediaQueryListener.registerMediaQueries();

// Container needs the store!
container.setStore(store);

if (initialState) {
	store.dispatch(normalizeInitialDataAction());
}

render(<AppRoot store={store} />, app);



// WEBPACK FOOTER //
// ./index.js